<style scope>
  .w-full { width: 100% }
</style>

<template>
  <section class="container">

    <portal-box style="min-height: 600px">
      <h1 slot="titulo" class="title">
        <b-field>
          <b-radio-button v-model="tipoSelecionado"                         
                          native-value="orcamentoCliente"
                          type="is-primary">
            <span>Orçamentos (Cliente da Base)</span>
          </b-radio-button>
          <b-radio-button v-model="tipoSelecionado"                         
                          native-value="orcamentoInativo"
                          type="is-primary">
            <span>Orçamentos (Inativo)</span>
          </b-radio-button>
          <b-radio-button v-model="tipoSelecionado"
                          native-value="orcamentoProspect"
                          type="is-primary">
            <span>Orçamentos (Prospect)</span>
          </b-radio-button>
        </b-field>
      </h1>

      <template v-if="tipoSelecionado === 'orcamentoCliente'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Cliente">
            <b-input v-model="filtro.clienteParam" placeholder="código ou nome"/>
          </b-field>

          <b-field label="Código do orçamento">
            <b-input v-model="filtro.pedidoParam" placeholder="código ou código web"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <template v-if="tipoSelecionado === 'orcamentoInativo'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Cliente">
            <b-input v-model="filtro.clienteParam" placeholder="código ou nome"/>
          </b-field>

          <b-field label="Código do orçamento">
            <b-input v-model="filtro.pedidoParam" placeholder="código ou código web"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <template v-if="tipoSelecionado === 'orcamentoProspect'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Prospect">
            <b-input v-model="filtro.clienteParam" placeholder="razão ou fantasia"/>
          </b-field>

          <b-field label="Código do pedido">
            <b-input v-model="filtro.pedidoParam" placeholder="código ou código web"/>
          </b-field>

          <label class="label">Emissão</label>
          <b-field>
            <b-datepicker placeholder="Início" v-model="filtro.emissaoInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Fim" v-model="filtro.emissaoFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.emissaoFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>

        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <lista-cliente :lista="lista" :loading="loading" :parametros="parametros"
                     v-if="tipoSelecionado === 'orcamentoCliente'"></lista-cliente>
      <lista-inativo :lista="lista" :loading="loading" :parametros="parametros"
                     v-if="tipoSelecionado === 'orcamentoInativo'"></lista-inativo>
      <lista-prospect :lista="lista" :loading="loading"  :parametros="parametros"
                     v-if="tipoSelecionado ==='orcamentoProspect'"></lista-prospect>
    </portal-box>
  </section>
</template>

<script>
  import { auth } from '../../mixins/auth'
  import { listagem } from '../../mixins/listagem'
  import {mask} from 'vue-the-mask'
  import ListaCliente from './ListaCliente'
  import ListaInativo from './ListaInativo'
  import ListaProspect from './ListaProspect'
  
  export default {
    mixins: [auth, listagem],
    directives: {mask},
    components: {ListaCliente, ListaProspect, ListaInativo},
    created () {
      this.metodo = 'PUT'
      if (this.$store.state.parametros.MENU_SISTEMA && this.$store.state.parametros.MENU_SISTEMA.indexOf('ORCAMENTO_CLIENTE_BASE') > -1) {
        this.url = this.$URL.ORCAMENTO.CLIENTE
        this.tipoSelecionado = 'orcamentoCliente'
        this.filtro.ORIGEM_CLIENTE = 'B'
      } else if (this.$store.state.parametros.MENU_SISTEMA && this.$store.state.parametros.MENU_SISTEMA.indexOf('ORCAMENTO_INATIVO') > -1) {
        this.url = this.$URL.ORCAMENTO.INATIVO
        this.tipoSelecionado = 'orcamentoInativo'
        this.filtro.ORIGEM_CLIENTE = 'I'
      } else {
        this.url = this.$URL.ORCAMENTO.PROSPECT
        this.tipoSelecionado = 'orcamentoProspect'
        this.filtro.ORIGEM_CLIENTE = 'P'
      }
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/orcamento/consulta').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    data () {
      return {
        tipoSelecionado: ''
      }
    },
    methods: {
      filtrarSelecionado () {
        if (this.tipoSelecionado === 'orcamentoCliente') {
          this.filtro.ORIGEM_CLIENTE = 'B'
          this.url = this.$URL.ORCAMENTO.CLIENTE
        } else if (this.tipoSelecionado === 'orcamentoInativo') {
          this.filtro.ORIGEM_CLIENTE = 'I'
          this.url = this.$URL.ORCAMENTO.INATIVO
        } else {
          this.filtro.ORIGEM_CLIENTE = 'P'
          this.url = this.$URL.ORCAMENTO.PROSPECT
        }
        this.filtrar()
      },
      limparFiltro () {
        this.filtro = {}
        if (this.tipoSelecionado === 'orcamentoCliente') {
          this.filtro.ORIGEM_CLIENTE = 'B'
          this.url = this.$URL.ORCAMENTO.CLIENTE
        } else if (this.tipoSelecionado === 'orcamentoInativo') {
          this.filtro.ORIGEM_CLIENTE = 'I'
          this.url = this.$URL.ORCAMENTO.INATIVO
        } else {
          this.filtro.ORIGEM_CLIENTE = 'P'
          this.url = this.$URL.ORCAMENTO.PROSPECT
        }
        this.filtrar()
      }
    },
    watch: {
      tipoSelecionado (value) {
        this.lista = []
        this.limparFiltro()
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/Lista.vue